import React from 'react';
import ApiCustomer from '../code/api/ApiCustomer';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Customer from '../code/models/Customer';
import SendEmailModel from '../code/models/SendEmailModel';
import EmailEditor from "./emaileditor/EmailEditor";
import Toaster from "./Toaster";
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import ApiEmailTemplates from "../code/api/ApiEmailTemplates";
import EmailTemplate from "../code/models/EmailTemplate";

import '../css/messagingsendemail.css';

const templateButtonIcon = require('../images/browser-grey.png');

interface IMessagingSendEmail {
  currentUser: AuthAdminUserModel;
  customer: Customer;
}
export default function MessagingSendEmail({ currentUser, customer }: IMessagingSendEmail) {
  const [toastMessage, setToastMessage] = React.useState<string>("");
  const [emailMessage, SetEmailMessage] = React.useState<string>("");
  const [emailSubject, SetEmailSubject] = React.useState<string>("");
  const [emailSending, SetEmailSending] = React.useState<boolean>(false);
  const [refresherKey, SetRefresherKey] = React.useState<string>("view1");

  const [emailMessageDefault, SetEmailMessageDefault] = React.useState<string>("");
  const [emailSubjectDefault, SetEmailSubjectDefault] = React.useState<string>("");
  const [sendGridTemplateId, SetSendGridTemplateId] = React.useState<string>("");


  // email templates
  const [templates, setTemplates] = React.useState<EmailTemplate[]>([]);
  const [modal, setModal] = React.useState(false);
  const toggleModal = () => setModal(!modal);

  React.useEffect(() => {
    ApiEmailTemplates.getEmailTemplates().then((temps) => {
      setTemplates(temps);
    });
  }, []);

  function validate() {
    return !!emailMessage && !!emailSubject;
  }

  function handleSendEmailClick() {
    if (validate()) {
      const dataContract: SendEmailModel = {
        "adminId": currentUser.id,
        "customerId": customer.customerId,
        "subject": emailSubject,
        "message": emailMessage,
        "sendGridId": sendGridTemplateId
      };

      SetEmailSending(true);

      ApiCustomer.sendEmail(dataContract).then(data => {
        setToastMessage("The email has been sent to the customer.");
        SetEmailSubject("");
        SetEmailMessage("");
        SetRefresherKey(`view${new Date().getMilliseconds()}`);
      }).finally(() => {
        SetEmailSending(false);
      });
    } else {
      setToastMessage("Fill in the subject and message to send the email.");
    }
  }

  function selectTemplateClick(temaplateId: number): void {
    var tmpl = templates.find((t) => t.emailTemplateId === temaplateId);

    if (!!tmpl) {
      SetEmailSubjectDefault(tmpl.subject);
      SetEmailMessageDefault(tmpl.template);
      SetEmailSubject(tmpl.subject);
      SetEmailMessage(tmpl.template);
      SetSendGridTemplateId(tmpl.sendGridTemplateId);
      toggleModal();
    }
  }

  function buildTemplateList() {
    return templates.map((t) => {
      return (
        <div className="messaging-sendemail-template" onClick={() => selectTemplateClick(t.emailTemplateId)}>{t.name}</div>
      )
    });
  }

  function renderTemplateModal() {
    return (
      <Modal id="selectEmailTemplateModal" isOpen={modal} toggle={toggleModal} size="md" fullscreen="md" backdrop={true} scrollable={true}>
        <ModalHeader toggle={toggleModal}>
          <h5 className="modal-title">Select Email Template</h5>
        </ModalHeader>
        <ModalBody key={"sndemltmpl" + templates.length}>
          {buildTemplateList()}
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-primary" onClick={toggleModal}>Cancel</button>
        </ModalFooter>
      </Modal>
    )
  }

  function chooseTemplateClick(): void {
    toggleModal();
  }

  function renderSendGridInfo(): React.ReactNode {
    return(
      <div className="col-md-2">

        <label htmlFor="templateSendgridId" className="form-label text-nowrap">SendGrid Id</label>
        <input className="form-control"
            id="templateSendgridId" defaultValue={sendGridTemplateId} autoComplete={"off"}
            onChange={(e) => {SetSendGridTemplateId(e.target.value)}}></input>
      </div>
    )
  }

  return (
    <React.Fragment key={refresherKey}>
      <div className="container-flow">
        <div className="row messaging-sendemail-top">
          <div className="col-md-4">
            <label htmlFor="messageSubject" className="form-label">Subject</label>
            <input id="messageSubject" type="text" className="form-control" placeholder="enter subject here"
              defaultValue={emailSubjectDefault} onChange={(e) => { SetEmailSubject(e.target.value); }} />
            <button className="btn templates"><img src={templateButtonIcon} alt="Temp" onClick={chooseTemplateClick} /></button>            
          </div>
          {sendGridTemplateId && renderSendGridInfo()}
          <div className="col-md-2">
            {!emailSending && <button className="btn btn-outline-primary messaging-sendemail-button" onClick={handleSendEmailClick}>Send Email</button>}
            {emailSending && <Spinner color="primary" className="messaging-sendemail-button" />}
          </div>
        </div>
      </div>
      <div className='row messaging-sendemail-editor'>
        <EmailEditor onChange={(value: string) => SetEmailMessage(value)} initialValue={emailMessageDefault} templateTags={undefined} previewMode={false} />
      </div>
      <Toaster title="Send Email" subtitle={customer.name} message={toastMessage} key={"custsendemailtoast"} />
      {renderTemplateModal()}
    </React.Fragment>
  )
}
